import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { QueueService } from 'src/app/_services/queue.service';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { UserService } from 'src/app/_services/user.service';
import { CategoryService } from 'src/app/_services/category.service';
import { AppConfig } from 'src/assets/config/config/app-config';

@Component({
  selector: 'app-queue-management',
  templateUrl: './queue-management.component.html',
  styleUrls: ['./queue-management.component.scss']
})
export class QueueManagementComponent implements OnInit {
  allQueuesDataSource: MatTableDataSource<any>
  allQueues: any[]
  displayedColumns = ["queue_name", "queue_groups", "createdby", "createdate", "queue_status", "actions"];
  queueData: any
  currentUser: User
  queuesCount: number
  queueCreated: boolean = false;
  queueUpdated: boolean = false;
  openQueueForm: boolean = false
  noQueues: boolean = false
  searchCtrl: string = "";
  usersList = [];
  allCategories: any;
  categories: string[]
  allQueueLabels: any[]
  completeOptions: string[]
  terminateOptions: string[]

  constructor(
    private queueService: QueueService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private categoryService: CategoryService,
    private config: AppConfig
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.allQueuesDataSource.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.allQueuesDataSource.paginator = this.paginator;
    }
  }

  ngOnInit(): void {
    this.completeOptions = this.config.getConfig("workflowCompleteOptions")
    this.terminateOptions = this.config.getConfig("workflowTerminateOptions")
    this.userService.getAll().subscribe(usersList => { this.usersList = usersList; });
    this.categoryService.getAll()
      .subscribe(categories => {
        this.allCategories = categories;
      });
    this.getAllQueuesHandler()
  }

  getAllQueuesHandler() {
    this.queueService.getAllQueues().subscribe(queues => {
      if (queues == "No queues to display") {
        this.noQueues = true
        this.allQueuesDataSource = null
        this.allQueues = null;
      } else {
        this.allQueues = queues
        this.allQueuesDataSource = new MatTableDataSource(this.allQueues);
        this.allQueuesDataSource.sort = this.sort;
        this.allQueuesDataSource.paginator = this.paginator;
        this.queuesCount = queues.length
        this.noQueues = false
        console.log(this.allQueues)
      }
    });
  }

  refreshPage() {
    this.ngOnInit();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.allQueuesDataSource.filter = filterValue.trim().toLowerCase();

    if (this.allQueuesDataSource.paginator) {
      this.allQueuesDataSource.paginator.firstPage();
    }
  }

  displayPage() {
    this.openQueueForm = false
    this.back();
    this.refreshPage()
  }

  back() {
    this.queueCreated = false;
    this.queueUpdated = false
  }

  createQueueHandler() {
    var createQueuePayload =
    {
      default: this.queueData.default,
      complete_options: this.queueData.complete_options,
      terminate_options: this.queueData.terminate_options,
      groups: this.queueData.groups,
      assign: this.queueData.assign,
      sla: this.queueData.sla,
      queue_attributes: this.queueData.queue_attributes,
      supervisor_groups: this.queueData.supervisor_groups
    };
    this.queueService.createQueue(createQueuePayload, this.queueData.name).subscribe(data => {
      this.queueCreated = true
      this.getAllQueuesHandler()
    })
  }

  openNewQueueForm(event) {
    this.queueData =
    {
      title: "Create Queue",
      button: "Create",
      name: null,
      groups: [],
      supervisor_groups:[],
      status: null,
      queue_action: {
        categories: []
      },
      sla: 0,
      queue_attributes: [],
      assign: [],
      complete_options: [],
      terminate_options: [],
      default: []
    };
    this.openQueueForm = true
  }

  updateQueueHandler() {
    var updatedQueuePayload =
    {
      default: this.queueData.default,
      complete_options: this.queueData.complete_options,
      terminate_options: this.queueData.terminate_options,
      groups: this.queueData.groups,
      assign: this.queueData.assign,
      sla: this.queueData.sla,
      queue_attributes: this.queueData.queue_attributes,
      supervisor_groups: this.queueData.supervisor_groups
    };
    this.queueService.updateQueue(updatedQueuePayload, this.queueData.name).subscribe(data => {
      this.queueUpdated = true
      this.getAllQueuesHandler()
    })
  }

  openUpdateQueueForm(event, queue) {
    console.log("update queue", queue, queue.terminate_options, this.terminateOptions
    )
    this.queueData =
    {
      title: "Update Queue",
      button: "Update",
      name: queue.queue,
      groups: queue.groups,
      supervisor_groups: queue.supervisor_groups,
      queue_action: {
        categories: []
      },
      sla: queue.sla,
      default: queue.default,
      queue_attributes: queue.queue_attributes,
      assign: queue.assign,
      complete_options: queue.complete_options,
      terminate_options: queue.terminate_options,
    };
    this.allQueueLabels = queue.queue_attributes
    console.log("Queue Details(update) >> ", this.queueData)
    this.openQueueForm = true
  }

  getDisplayLabelstData(selectedCategories) {
    this.allQueueLabels = []
    for (let category of this.allCategories.results) {
      for (let selectedCategory of selectedCategories) {
        if (category.id == selectedCategory) {
          for (let metaData of category.meta_data_definition) {
            if (metaData.active) {
              for (let property of metaData.properties) {
                var obj = {}
                obj["name"] = property.name
                obj["value"] = property.name
                this.allQueueLabels.push(obj)
              }
            }
          }
        }
      }
    }
    this.allQueueLabels = this.removeDuplicateFromDisplayList(this.allQueueLabels, "value")
  }

  removeDuplicateFromDisplayList = (array, key) => {
    var check = new Set();
    return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
  }
}
